import React, { useState } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { TabSelector } from "../tabSelector/tabSelector";
import { CARGO_PAGES } from "../../constants/cargo/pages";
import localizationKeys from "../../i18n/localizationKeys";
import { Box } from "@mui/material";
import { Screenshot } from "../trendPage/commonComponent/screenshot";
import DownloadIcon from "../trendPage/commonComponent/downloadIcon";
import { AdditionalContainer } from "../tabSelector/additionalContainer";
import { detectDevice, DEVICE_TYPE } from "../../constants/detectDevice";

export const DisplayTabSelector = (props) => {
  const { vesselId, page, pageRef, interval, selectedChart } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isTouchDevice = [DEVICE_TYPE.PHONE, DEVICE_TYPE.TABLET].includes(detectDevice);
  const [open, setOpen] = useState(false);

  const commonTabs = (t) => [
    {
      name: t(localizationKeys.Transport),
      id: CARGO_PAGES.TRANSPORT,
    },
    {
      name: t(localizationKeys.Handling),
      id: CARGO_PAGES.HANDLING,
    },
  ];

  const clickTab = (id) => {
    navigate(`/cargo/${id}/${vesselId}`);
  };

  return (
    <TabSelector
      tabs={commonTabs(t)}
      selectedOne={page}
      clickHandler={clickTab}
    >
      <>
        <Box component={"div"} sx={{
          cursor: "pointer",
          position: "relative",
          height: "48px",
          right: "36px",
          display: "flex",
          zIndex: 60,
          alignItems: "center",
          "& div": {
            marginLeft: "12px",
          },
        }}>
          {!isTouchDevice && <Screenshot element={pageRef.current} isCargo={true} />}
          <div onClick={() => setOpen(!open)}>
            <DownloadIcon color="#ffffff" opacity="1" />
          </div>
        </Box>
        {open && <AdditionalContainer interval={interval} vesselId={vesselId} setOpen={setOpen} selectedTab={page} selectedChart={selectedChart}/>}
      </>
    </TabSelector>
  );
};

DisplayTabSelector.propTypes = {
  vesselId: PropTypes.string,
  page: PropTypes.string,
  pageRef: PropTypes.any,
  interval: PropTypes.number,
  selectedChart: PropTypes.string,
};
